import type { ResponseError } from '@capturi/request'
import request from '@capturi/request'
import { type UseQueryResult, useQuery } from '@tanstack/react-query'

type Response = {
  integrationTypes: Integration[]
}

export type Integration = {
  channel: 'audio' | 'text'
  color: string
  type: string
  name: string
}
type IntegrationAudio = Integration & {
  channel: 'audio'
}

type IntegrationText = Integration & {
  channel: 'text'
}

type Channel = 'audio' | 'text' | undefined
const isAudio = (i: Integration): i is IntegrationAudio => i.channel === 'audio'

const isText = (i: Integration): i is IntegrationText => i.channel === 'text'

const selectAudio = (r: Response): IntegrationAudio[] =>
  r.integrationTypes.filter(isAudio)

const selectText = (r: Response): IntegrationText[] =>
  r.integrationTypes.filter(isText)
const selectAll = (r: Response): Integration[] => r.integrationTypes

const select = (channel: Channel) => {
  if (channel === 'audio') return selectAudio
  if (channel === 'text') return selectText
  return selectAll
}

export const useIntegrationTypes = (
  channel?: Channel,
): UseQueryResult<Integration[], ResponseError> =>
  useQuery({
    queryKey: ['superpowers', 'integrations', 'types'],
    queryFn: () => request.get<Response>('importer/mr-integration/types'),
    select: select(channel),
  })
